module.exports = __webpack_public_path__ + "static/media/fist.d1b25a44.svg";